import { createAction, props } from '@ngrx/store';

export const initializeUiState = createAction('[UI] Initialize State');

export const toggleReportSidebarTab = createAction(
  '[UI] Toggle Sidebar Tab',
  props<{
    tabIndex: number;
    isClosing: boolean;
  }>()
);

export const toggleAside = createAction(
  '[UI] Toggle Aside',
  props<{ isOpen: boolean }>()
);

export const toggleDarkMode = createAction(
  '[UI] Toggle Dark Mode',
  props<{ isDarkMode: boolean }>()
);

export const toggleSubscriptionBanner = createAction(
  '[UI] Toggle Subscription Banner',
  props<{ isVisible: boolean }>()
);

export const toggleSidebarCollapsed = createAction(
  '[UI] Toggle Sidebar Collapsed',
  props<{ isCollapsed: boolean }>()
);
